/**
 * cl-core/brands — 시공사 ↔ 아파트 브랜드 사전 «단일 원본»(HC 정리 2026-10-24). 순수 TS · import 0(Deno 공용).
 *
 * 한 줄 = 시공사 하나. 여기서 두 표를 «유도» 한다(사본 금지):
 *   BRAND_OWNER          브랜드 → 시공사 정본 키(소문자) — cl-core/fact-check 의 브랜드 소유 오기 판정·builder 칸 브랜드 해석.
 *   BUILDER_BRAND_LABEL  시공사 표기 → 대표 브랜드 라벨(순서 = 포함 검사 우선순위) — parse-announcement 의 brand_name.
 * ⚠️ 줄 순서가 뜻이다 — 모집공고 constructor_nm 은 «포함» 으로 첫 일치를 고른다(현대건설이 현대엔지니어링보다 앞).
 */
export interface BuilderBrandRow {
  /** 모집공고·원장에 적히는 시공사 표기. */
  builder: string;
  /** fact-check 정본 키(기본 = builder 소문자). */
  key?: string;
  /** 대표 브랜드 라벨(모집공고 brand_name) — 없으면 그 시공사는 라벨을 달지 않는다. */
  label?: string | null;
  /** 이 시공사 소유 브랜드(본문 «브랜드 → 시공사» 판정 · 소문자 비교). */
  brands: readonly string[];
}

export const BUILDER_BRANDS: readonly BuilderBrandRow[] = [
  { builder: '삼성물산', label: '래미안', brands: ['래미안'] },
  { builder: 'GS건설', label: '자이', brands: ['자이'] },
  { builder: '현대건설', label: '힐스테이트', brands: ['힐스테이트', '디에이치'] },
  { builder: '대우건설', label: '푸르지오', brands: ['푸르지오', '써밋'] },
  { builder: 'DL이앤씨', label: '아크로', brands: ['e편한세상', '아크로'] },
  { builder: 'SK에코플랜트', label: 'SK VIEW', brands: ['sk뷰'] },
  { builder: '포스코이앤씨', label: '더샵', brands: ['더샵', '오티에르'] },
  { builder: '롯데건설', label: '롯데캐슬', brands: ['롯데캐슬', '르엘'] },
  { builder: '한화건설', key: '한화', label: '포레나', brands: ['포레나'] },
  { builder: '호반건설', label: '호반써밋', brands: ['호반베르디움', '호반써밋'] },
  { builder: 'HDC현대산업개발', label: '아이파크', brands: ['아이파크'] },
  { builder: '두산건설', label: '두산위브', brands: ['위브', '두산위브'] },
  { builder: '대림산업', label: 'e편한세상', brands: [] },
  { builder: 'DL건설', label: 'e편한세상', brands: ['e편한세상'] },
  { builder: '태영건설', label: '데시앙', brands: ['데시앙'] },
  { builder: '제일건설', label: '제일풍경채', brands: ['풍경채'] },
  { builder: '한양', label: '수자인', brands: ['수자인', '한양수자인'] },
  { builder: '코오롱글로벌', label: '하늘채', brands: ['하늘채'] },
  { builder: '금호건설', label: '어울림', brands: ['어울림', '금호어울림', '아테라'] },
  { builder: '현대엔지니어링', label: '힐스테이트', brands: ['힐스테이트'] },
  { builder: '중흥건설', label: 'S-클래스', brands: [] },
  { builder: '우미건설', label: '우미린', brands: ['우미린'] },
  { builder: '에이치엘디앤아이한라', label: '에피트', brands: ['에피트'] },
  { builder: '한라', label: '에피트', brands: ['에피트'] },
  { builder: '쌍용건설', label: '더플래티넘', brands: ['더플래티넘'] },
  { builder: '계룡건설', label: '리슈빌', brands: ['엘리프', '리슈빌'] },
  // 라벨은 달지 않고 «브랜드 → 시공사» 판정에만 쓰는 줄
  { builder: '대방건설', brands: ['디에트르'] },
  { builder: '동부건설', brands: ['센트레빌'] },
  { builder: '반도건설', brands: ['유보라'] },
  { builder: '서희건설', brands: ['스타힐스'] },
  { builder: '한신공영', brands: ['더휴'] },
  // 2026-10-24 — 부울경 다수 브랜드(신규 현장 자동 발견이 «소유 시공사 미상» 으로 막던 것)
  { builder: '동일', brands: ['동일스위트'] },
  { builder: '동원개발', brands: ['비스타동원'] },
  { builder: '중흥토건', brands: ['중흥s-클래스'] },
  { builder: '금강주택', brands: ['펜테리움'] },
  { builder: 'KCC건설', brands: ['스위첸'] },
  { builder: 'HJ중공업', brands: ['해모로'] },
  { builder: '협성건설', brands: ['협성휴포레'] },
  // 2026-11-05 — 11월 분양 신규 현장 자동 발견이 «소유 시공사 미상» 으로 막던 브랜드
  { builder: '양우건설', brands: ['양우내안애', '내안애'] },
  { builder: '이수건설', brands: ['브라운스톤'] },
  // 2026-10-26 national-preempt — 전국 분양예정 기사 단지의 «소유 시공사 미상» 차단 해소(엘리프 논산 디에디션 등 실측).
  { builder: '효성중공업', brands: ['해링턴'] },
  { builder: '진흥기업', brands: ['해링턴'] },
  { builder: '대광건영', brands: ['로제비앙'] },
  { builder: '라온건설', brands: ['라온프라이빗'] },
  { builder: '시티건설', brands: ['시티프라디움'] },
  { builder: '서한', brands: ['서한이다음'] },
  { builder: '금성백조', brands: ['예미지'] },
  { builder: '남광토건', brands: ['하우스토리'] },
  { builder: '아이에스동서', brands: ['에일린의뜰'] },
  { builder: '신동아건설', brands: ['파밀리에'] },
  { builder: '화성산업', brands: ['파크드림'] },
];

const keyOf = (r: BuilderBrandRow): string => r.key ?? r.builder.toLowerCase();

/** 브랜드 → 시공사 정본 키 목록(소문자 키). */
export const BRAND_OWNER: Readonly<Record<string, readonly string[]>> = (() => {
  const out: Record<string, string[]> = {};
  for (const r of BUILDER_BRANDS) for (const b of r.brands) (out[b] ??= []).push(keyOf(r));
  return out;
})();

/** 시공사 표기 → 대표 브랜드 라벨(순서 보존 — 첫 «포함» 일치가 이긴다). */
export const BUILDER_BRAND_LABEL: ReadonlyArray<readonly [string, string]> = BUILDER_BRANDS
  .filter((r): r is BuilderBrandRow & { label: string } => !!r.label)
  .map((r) => [r.builder, r.label] as const);

/** 시공사 표기에 든 첫 시공사의 대표 브랜드 라벨. 없으면 null. */
export function brandLabelForBuilder(constructorName: string | null | undefined): string | null {
  const s = String(constructorName ?? '');
  if (!s) return null;
  for (const [builder, label] of BUILDER_BRAND_LABEL) if (s.includes(builder)) return label;
  return null;
}

/**
 * 단지명 브랜드 낱말 사전(«브랜드명 확정» 판정 · 분양예정 승격) — presale/promote PROMO_BRANDS · cafe p-common BRAND_WORDS 가 같은 목록이었다.
 *   cvn-brand-registry(DB)가 정본이 되면 그쪽으로 옮긴다.
 */
export const BRAND_WORDS: readonly string[] = ['자이', '래미안', '푸르지오', '힐스테이트', '더샵', 'e편한세상', '이편한세상', '아이파크', '롯데캐슬', '데시앙', '포레나', '써밋', '센트레빌', '디에이치', '아크로', '르엘', '스위첸', '하늘채', '위브', '우미린', '중흥S', '제일풍경채', '한신더휴', '엘리프', '리슈빌', '파밀리에', '서희스타힐스', '호반', '대방', '모아', '동일', '시티프라디움', '어울림', '해모로', '코아루', '베르디움', 'SK뷰', '트리븐', '라피아노',
  // 2026-10-26 national-preempt — 소유 시공사가 위 BUILDER_BRANDS 에 있는 전국 브랜드(기사 단지명 추출·브랜드명 확정 판정).
  '에피트', '아테라', '해링턴', '유보라', '디에트르', '펜테리움', '비스타동원', '동일스위트', '로제비앙', '라온프라이빗', '하우스토리', '예미지', '서한이다음', '더플래티넘', '에일린의뜰',
  // 2026-11-05 — 기사 단지명 추출에서 빠지던 브랜드(소유 시공사는 위 표에 있음)
  '수자인', '양우내안애', '브라운스톤'];
